import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaCopy, FaEdit, FaLaptop, FaBuilding } from "react-icons/fa";
import CustomDropdown from '../../common/CustomDropdown';

const BasicDetails = ({
  handleSaveEvent,
  handleFileChange,
  uploadedLogo,
  eventName,
  setEventName,
  description,
  setDescription,
  errors,
  setEventURL,
  eventMode,
  setEventMode,
  eventUrl,
  eventUrlBase,
  eventUrlSlug,
  setEventUrlSlug,
  setIsEditingUrl,
  handleSaveUrl,
  isEditingUrl,
  eventDetailsUrl,
  setEventDetailsUrl,
  imageError,
  handleCopyUrl,
  eventTypeList,
  setEventType,
  eventType,
  getValidation
}) => {
  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const imgElement = document.querySelector(".width_profile_image");
  //       imgElement.src = e.target.result;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleImageUpload = () => {
    document.getElementById("imageUploadInput").click();
  };

  const handleToggleChange = (value) => {
    setEventMode(value);
  };

  return (
    <div className="">
      <div className="card shadow-sm">
        {/* <div className="card-header setting_card_heading setting_card_heading_size">
          <h5>Basic Details</h5>
          <p>
            Enter the essential details of your event, including name, logo,
            registration URL, and mode.
          </p>
        </div> */}
        <div className="card-body settings_body_div border-0">
          <div className="row">
            <div className="col-md-12">
              <label className="fw-bold">Event Logo</label>
              <div className=" ">
                <div className="row align-center gap-15 pr-3 pl-3">
                  <div className=" ">
                    <div className="pos_relative">
                      <div className="pos_re">
                        <img
                          src={uploadedLogo || "https://placehold.co/700x400"}
                          width="100"
                          height="100"
                          className="img-thumbnail width_profile_image"
                          alt="Uploaded Image"
                          onClick={handleImageUpload}
                          style={{
                            cursor: "pointer",
                            objectFit: "cover",
                            border: "2px solid #ddd",
                            borderRadius: "4px",
                          }}
                        />
                        <i
                          onClick={handleImageUpload}
                          className="fa fa-pencil upload_image_edit_icon"
                          style={{ cursor: "pointer" }}
                        />
                        <input
                          type="file"
                          id="imageUploadInput"
                          style={{ display: "none" }}
                          accept="image/*"
                          onChange={handleFileChange("logo")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className=" ">
                    <div className="w-100 ">
                      <p>
                        The image should be JPG, PNG, SVG, GIF Format
                        Recommended Dimension: 150 × 100 pixels / Height: 150
                        pixels.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {imageError && <p className="text-danger mt-1">{imageError}</p>}
            </div>

            <div className="col-md-6 pb-2">
              <div className="row">
                <div className="col-md-12 pb-2">
                  <label className="fw-bold">
                    Event Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={eventName}
                    onChange={(e) => setEventName(e.target.value)}
                    placeholder="Enter event name"
                  />
                  {errors.eventName && (
                    <p className="text-danger mt-1">{errors.eventName}</p>
                  )}
                </div>

                <div className="col-md-12 pb-2 event_categery_custom_input">
                  <label className="fw-bold">
                    Event Category <span className="text-danger">*</span>
                  </label>
                  <CustomDropdown
                    dropdownData={eventTypeList}
                    dropdownValue={eventType}
                    setDropdownValue={setEventType}
                    ShouldValidate={true}
                    className=""
                    name="Event Category"
                    fieldName="event_type"
                    errors={errors}
                    eventType={"Update"}
                  />
                  {errors.eventType && (
                    <p className="text-danger mt-1">{errors.eventType}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6 pb-2">
              <label className="fw-bold">
                Event Description <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control custom-textarea"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
              {/* {errors.description && (
                <p className="text-danger mt-1">{errors.description}</p>
              )} */}
            </div>

            <div className="col-md-6 pb-2">
              <label className="fw-bold">
                Event Mode <span className="text-danger">*</span>
              </label>
              <div className="webinar_onsite_flexdiv">
                <button
                  type="button"
                  className={`btn ${eventMode === "Webinar" ? "active" : ""}`}
                  onClick={() => handleToggleChange("Webinar")}
                  disabled
                >
                  <FaLaptop className="me-2" /> Webinar
                </button>
                <button
                  type="button"
                  className={`btn ${eventMode === "On-Site" ? "active" : ""}`}
                  onClick={() => handleToggleChange("On-Site")}
                >
                  <FaBuilding className="me-2" /> On-Site
                </button>
              </div>
            </div>
            <div className="col-md-6 pb-2">
              <div>
                <label className="fw-bold">Event URL <span className="text-danger">*</span></label>
                <div className="d_flex_widthstep3">
                  <div className="unlink_div_flex">
                    <span className="link_div_step3">
                      <i className="fa fa-unlink"></i>
                    </span>
                    <input
                      type="text"
                      className="input_event_wid form-control"
                      value={eventUrl}
                      readOnly
                    />
                  </div>
                  <button
                    className="btn apply_btn custom_buton"
                    onClick={()=>handleCopyUrl(eventUrl)}
                  >
                    Copy
                  </button>
                  {!isEditingUrl && (
                    <button
                      className="btn reset_btn custom_buton"
                      onClick={() => setIsEditingUrl(true)}
                    >
                      Edit
                    </button>
                  )}
                </div>
                {isEditingUrl && (
                  <div className="pt-2">
                    <div className="d_flex_widthstep3">
                      <span className="pr-1">{eventUrlBase}</span>
                      <input
                        type="text"
                        className="form-control"
                        value={eventUrlSlug}
                        onChange={(e) => setEventUrlSlug(e.target.value)}
                      />
                    </div>
                    <div className="member_button_flex pt-2">
                      <button
                        className="btn btn-outline-danger"
                        onClick={() => setIsEditingUrl(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleSaveUrl}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6 pb-2">
              <div>
                <label className="fw-bold">Event Details URL</label>
                <div className="d_flex_widthstep3">
                  <div className="unlink_div_flex">
                    <span className="link_div_step3">
                      <i className="fa fa-unlink"></i>
                    </span>
                    <input
                      type="text"
                      className="input_event_wid form-control"
                      value={eventDetailsUrl}
                      onChange={(e) => setEventDetailsUrl(e.target.value)}
                    />
                  </div>
                  {eventDetailsUrl && (
                  <button
                    className="btn apply_btn custom_buton"
                    onClick={()=>handleCopyUrl(eventDetailsUrl)}
                  >
                    Copy
                  </button>)}
                </div>
              </div>
            </div>
            <div className="col-md-6 pb-2"></div>
            <div className="col-md-6 pt-3 pb-2">
              <button
                className="btn btn-outline-primary"
                onClick={handleSaveEvent}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDetails;
